import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-ops-analytics-desk",
  "use": "icon-soc-ops-analytics-desk-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-ops-analytics-desk\">\n<g transform=\"translate(-80 -80) scale(1.18)\">\n  <path d=\"M192 224h640v96H192V224zm64 128h512v448H256V352zm96 80v64h320v-64H352zm0 128v64h288v-64H352z\" />\n  <path d=\"M352 560v160h64V560h-64zm112 48v112h64V608h-64zm112-80v192h64V528h-64z\" />\n  <path d=\"M320 848h384v48H320v-48z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-ops-analytics-desk.svg
// module id = XYcN
// module chunks = 488